import React, { ReactElement } from "react";
import ReactDOM from "react-dom";

import { DataProviderContext } from "app/main/DataProvider";

/**
 * Will search for a DOM node with the given portalId and prepares a portal for the given component.
 * @param portalId
 * @param component
 */
export const usePortal = (portalId: string, component: ReactElement) => {
    const [render, setRender] = React.useState(false);

    React.useEffect(() => {
        const portal = window.document.getElementById(portalId);
        if (portal) {
            portal.innerHTML = "";
            setRender(true);
        }
    }, [portalId, setRender]);

    if (!render) {
        return null;
    }

    const portalNode = window.document.getElementById(portalId);

    if (!portalNode) {
        return null;
    }

    return ReactDOM.createPortal(component, portalNode);
};

/**
 * Test if we are in browser or SSR context. Returns true if we are in a browser
 */
export const useBrowserOnly = () => {
    const [browser, setBrowser] = React.useState(false);

    React.useEffect(() => {
        setBrowser(true);
    }, [setBrowser]);

    return browser;
};

/**
 * Return the current url from the context
 */
export const useUrl = (): string => {
    const context = React.useContext(DataProviderContext);

    return context.url;
};
